export const GET_CREDITS_LOADING = "get/credits/loading"
export const GET_CREDITS_ERROR = "get/credits/error"
export const GET_CREDITS_SUCCESS = "get/credits/success"
export const RESET_CREDITS = "reset/credits"